module.exports = __webpack_public_path__ + "officialStatic/img/gw-detailList1.7795955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/gw-detailList1.png
// module id = +GqC
// module chunks = 0